import React from 'react';
import { graphql } from 'gatsby';
import GraphQLErrorList from '../components/graphql-error-list';
import SEO from '../components/layout/seo';
import ContentSections from '../components/pagebuilder/content-sections';
import Section from '../components/sections/section';
import Container from '../components/layout/container';
import BlogGrid from '../components/sections/blog/Blog-grid';
import SectionHero from '../components/pagebuilder/section-hero';
import Navigation from '../components/sections/cycle/Navigation';

export const query = graphql`
  query BlogPageQuery {
    gatsby: site {
      config: siteMetadata {
        siteUrl
        title
        description
        userTwitter
      }
    }
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
    }
    page: sanityPage(slug: { current: { eq: "blog" } }) {
      ...Page
    }
    posts: allSanityPost(filter: { slug: { current: { ne: null } } }, sort: { fields: [publishedAt], order: DESC }) {
      nodes {
        ...Post
      }
    }
  }
`;

const BlogPage = (props) => {
  const { data, errors, location } = props;
  const {
    gatsby: { config },
    site,
    page,
    posts,
  } = data;

  const { hero, smallHero } = page;

  let { search = '', state, hash } = location;
  let searchSlug = '';
  let searchType = '';
  if (search.includes('tag')) {
    searchSlug = decodeURIComponent(search.replace('?tag=', ''));
    searchType = 'tag';
  } else if (search.includes('category')) {
    searchSlug = decodeURIComponent(search.replace('?category=', ''));
    searchType = 'category';
  }

  if (errors) {
    return <GraphQLErrorList errors={errors} />;
  }

  return (
    <>
      <Navigation />
      <SectionHero smallHero={smallHero} hero={hero} />
      <SEO
        title={page.title}
        description={page.seo?.meta_description}
        seoTitle={page.seo?.seo_title}
        keywords={page.seoKeywords || site.keywords}
        seoImage={page.seoImage?.asset?.img?.src}
        path={props.location.pathname}
      />
      <main>
        <Section>
          <Container>
            <BlogGrid searchSlug={searchSlug} searchType={searchType} posts={posts.nodes} />
            {page && page.content && <ContentSections content={page.content} />}
          </Container>
        </Section>
      </main>
    </>
  );
};

export default BlogPage;
